module.exports = __webpack_public_path__ + "assets/img/3-5.d18a4552.png";